import {AlertTypeDTO, Completable, pending, pristine} from 'kashable-mobile-common';

import {getNotifications} from '../apis/monitoring';
import {RootState} from '../store';

import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface NotificationParams {
    length?: number;
    offset?: number;
}

const INITIAL_STATE: Completable<AlertTypeDTO[]> = pristine();

export const fetchNotifications = createAsyncThunk(
    'notifications/fetch',
    async ({length = 5}: NotificationParams, {rejectWithValue}) => {
        const response = await getNotifications(length);

        if (response.error) {
            return rejectWithValue(response);
        }

        return response;
    },
);

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState: INITIAL_STATE,
    reducers: {
        updateNotifications: (state, action: PayloadAction<AlertTypeDTO[]>) => {
            const value = state.value ? [...state.value] : [];
            const newState = {
                ...state,
                value: value.map((item) => {
                    const currentNotification = action.payload.find(({gid}) => gid === item.gid);

                    if (currentNotification) {
                        return currentNotification;
                    }
                    return item;
                }),
            };
            return {...newState};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.pending, () => {
                return pending();
            })
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const selectNotifications = (state: RootState) => state.notifications;

export const {
    updateNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
